/**
 * Utilitaire pour vérifier que Three.js est chargé
 * Three.js est chargé via un script tag dans index.html pour garantir
 * qu'il existe avant que les bibliothèques ne soient chargées
 */

/**
 * Vérifie que Three.js est disponible et retourne une promesse résolue
 * @returns {Promise<Object>} L'instance de Three.js
 */
export const loadThree = async () => {
  // Si Three.js est déjà chargé globalement (via script tag dans index.html), l'utiliser
  if (typeof window !== 'undefined' && window.THREE) {
    return Promise.resolve(window.THREE);
  }

  // Si Three.js n'est pas encore chargé, attendre qu'il le soit
  return new Promise((resolve, reject) => {
    const checkInterval = setInterval(() => {
      if (typeof window !== 'undefined' && window.THREE) {
        clearInterval(checkInterval);
        resolve(window.THREE);
      }
    }, 50);

    // Timeout après 5 secondes
    setTimeout(() => {
      clearInterval(checkInterval);
      reject(new Error('Three.js failed to load within timeout'));
    }, 5000);
  });
};

/**
 * Obtient l'instance de Three.js (doit être chargée au préalable)
 * @returns {Object|null} L'instance de Three.js ou null si non chargée
 */
export const getThree = () => {
  if (typeof window !== 'undefined' && window.THREE) {
    return window.THREE;
  }
  return null;
};
